import React from "react";
import "./AILoadingCard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";
import { CHAT, CHAT_MESSAGES } from "../../../../../../util/constants";

export const AILoadingCard = ({ message, loadingText = CHAT_MESSAGES.LOADING }) => {
  const now = new Date();
  const day = now.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = now.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

  return (
    <div className={`order-chat-bubble ${message.role || "ai"}`}>
      <div className="order-ai-card ai-loading-card">
        <div className="order-ai-card-header">
          <div className="order-ai-card-title-logo">
            <img
              src={aiChatlogo}
              alt={CHAT.AXON_AI}
              aria-hidden="true"
              className="order-ai-logo"
              style={{ width: 32, height: 32 }}
            />
          </div>
          <div className="order-ai-card-title-Avatar">
            <span>{message.header?.title || CHAT.AXON_AI}</span>
            <div className="order-ai-card-time">{`${day} ${time}`}</div>
          </div>
        </div>

        <div className="order-ai-card-body">
          <div className="ai-loading-content">
            <div className="ai-loading-text">{loadingText}</div>
            <div className="ai-loading-bar">
              <div className="ai-loading-bar-fill"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
